import axios from 'axios'

/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const getinfoAboutUs = () => {
  return axios.get(`${process.env.API_URL}/about-us`)
}

